module.exports = "https://static.wmbcdn.com/uniweb/images/b60ef8294c43a76abecff0aa77f38b99.svg";